<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">Guides & Scouts Club</h1>
    <p class="lead mb-0 text-orange-light">“From Small Steps to Giant Leaps—We Lead!”</p>
  </div>
</div>

<div class="container px-lg-5 py-5">
  <div class="row g-5">
    <div class="col-12 col-lg-8">
      <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-4">
        <h3 class="fw-bold mb-4 text-success border-bottom pb-2">
          <i class="fa-solid fa-compass me-2"></i> Join the Girl Scouts & Guides Club
        </h3>
        
        <p class="lead text-muted mb-4" style="line-height: 1.8; text-align: justify;">
          Join the Girl Scouts and Guides Club at Shah Satnam Ji Girls’ College in Sirsa! At our club, we strive to serve with honour and lead with courage. Under the guidance of <strong>Dr Rishu Tomar</strong>, supported by <strong>Miss Raman</strong> and <strong>Miss Geeta</strong>, our vibrant and dynamic group is dedicated to fostering community spirit and service among students.
        </p>

        <h5 class="fw-bold text-success mb-3">Key Activities</h5>
        <ul class="list-group list-group-flush mb-4">
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Community Service Projects</strong>: Regular visits to local communities to provide aid and support.</div>
          </li>
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Awareness Campaigns</strong>: Organizing and participating in campaigns on health, environment, and social issues.</div>
          </li>
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Skill Development Workshops</strong>: Workshops aimed at enhancing life skills such as first aid, communication, and leadership.</div>
          </li>
          <li class="list-group-item bg-transparent px-0 py-2.5 text-muted border-0 d-flex gap-2">
            <i class="fa-solid fa-circle-check text-orange mt-1"></i>
            <div><strong>Outdoor Activities</strong>: Adventure camps, hikes, and other outdoor activities that promote physical fitness and resilience.</div>
          </li>
        </ul>

        <h5 class="fw-bold text-success mb-3">Our Vision</h5>
        <p class="text-muted mb-4" style="line-height: 1.7; text-align: justify;">
          We envision creating a generation of socially responsible young women. We believe in empowering our students to be compassionate leaders who can drive positive change in society.
        </p>

        <div class="join-info p-4 rounded-4 bg-light border-left-orange">
          <h6 class="fw-bold text-orange-dark mb-2"><i class="fa-solid fa-right-to-bracket me-2"></i> Join Us</h6>
          <p class="text-muted mb-0 small" style="line-height: 1.6;">
            We welcome all students to join the Girl Scouts and Guides Club and be part of a journey that promises growth, learning, and meaningful contributions to society. For more information, please contact <strong>Ms Raman Sethi</strong> or visit our office at Shah Satnam Ji Girls’ College.
          </p>
        </div>
      </div>
    </div>

    <!-- Right Sidebar with Leadership Team -->
    <div class="col-12 col-lg-4">
      <div class="sidebar-card p-4 shadow-sm rounded-4 bg-white border-top border-5 border-orange mb-4">
        <h5 class="fw-bold mb-4 text-orange-dark border-bottom pb-2">
          <i class="fa-solid fa-user-tie me-2"></i> Club Leadership
        </h5>
        
        <div class="d-flex flex-column gap-3">
          <div class="p-3 border rounded-3 bg-light">
            <h6 class="fw-bold mb-1 text-dark">Dr. Rishu Tomar</h6>
            <span class="small text-success fw-semibold">Club Director</span>
          </div>
          <div class="p-3 border rounded-3 bg-light">
            <h6 class="fw-bold mb-1 text-dark">Miss Raman Sethi</h6>
            <span class="small text-success fw-semibold">Co-Director</span>
          </div>
          <div class="p-3 border rounded-3 bg-light">
            <h6 class="fw-bold mb-1 text-dark">Miss Geeta</h6>
            <span class="small text-success fw-semibold">Assistant Co-Director</span>
          </div>
        </div>
      </div>

      <div class="sidebar-card p-4 shadow-sm rounded-4 bg-white border-top border-5 border-success">
        <h5 class="fw-bold mb-3 text-success">
          <i class="fa-solid fa-image me-2"></i> Activity Photos
        </h5>
        <div class="row g-2">
          <div class="col-6" *ngFor="let img of scoutImages">
            <div class="gallery-thumb rounded overflow-hidden shadow-sm">
              <img [src]="img" alt="Scouts & Guides" class="img-fluid gallery-img">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
